var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.item[_vm.options.filename] || _vm.value != null)?_c('a',{attrs:{"href":_vm.imgPath,"target":"_blank"}},[_c('img',{staticClass:"h-6 w-6 m-auto",class:_vm.options.classes,attrs:{"src":_vm.imgPath}})]):_c('i',{staticClass:"fas fa-user"})])
}
var staticRenderFns = []

export { render, staticRenderFns }